module.exports = function getResource(label, vars = []) {
    let resources = {
        advertisingCookieBannerControlText: `We use cookies to show you relevant offers and personalize your experience on our site. By clicking “accept”, you also allow us to share information with our advertising and analytics partners. See ${vars[0]}.`,
        privacyPolicy: 'Privacy Policy',
        advertisingCookieBannerButtonText: 'Accept',
        advertisingCookieBannerVariantText: `We value your privacy and do not sell your data. By clicking “accept”, however, you allow us to share information that we collect about you in our stores and online with third party advertising and analytics partners. See ${vars[0]}.`
    };
    return resources[label];
};
